
export const page = (data, current, pageSize) => {
  // 当前页码
  let cur = (current - 1) * pageSize;
  // 返回分页数据
  let retData = [];
  for (let i = 0; i < data.length; i++) {
    if (i >= cur && retData.length <= pageSize){
      retData.push(data[i]);
    }
    if (retData.length == pageSize){
      console.log("===="+retData);
      return retData;
    }
  }
  return retData;
}



// WEBPACK FOOTER //
// ./src/utils/page.js